import { Link } from 'react-router-dom';
import styles from './ObjectNirvana.module.css';

export default function ObjectNirvana() {
  return (
    <div className={styles.container}>
      <div className={styles.overlay} />
      <div className={styles.content}>
        <h1 className={styles.title}>Object Nirvana, Inc.</h1>
        <p className={styles.subtitle}>
          Consulting &amp; Software Development — Delivering Excellence for Over 20 Years
        </p>

        <section className={styles.intro}>
          <p>
            Object Nirvana is a consulting and software development firm with more than two decades of
            experience building robust, scalable systems for organizations of every size. From startups
            to enterprises, we partner with our clients to architect solutions that stand the test of
            time.
          </p>
        </section>

        <section className={styles.specialties}>
          <h2 className={styles.sectionTitle}>Our Specialties</h2>
          <div className={styles.grid}>
            <div className={styles.card}>
              <div className={styles.cardIcon}>☕</div>
              <h3>Java</h3>
              <p>
                Deep expertise in the Java ecosystem — from enterprise backend services and
                microservices to high-performance data pipelines. We leverage the JVM to its fullest
                potential.
              </p>
            </div>

            <div className={styles.card}>
              <div className={styles.cardIcon}>⚡</div>
              <h3>Scala</h3>
              <p>
                Functional and object-oriented programming with Scala, including ZIO, Cats, Akka, and
                Play. We build type-safe, concurrent systems that are both expressive and reliable.
              </p>
            </div>

            <div className={styles.card}>
              <div className={styles.cardIcon}>🌐</div>
              <h3>Distributed Systems</h3>
              <p>
                Designing and implementing fault-tolerant distributed architectures using Kafka,
                Kubernetes, event sourcing, and CQRS patterns for systems that scale globally.
              </p>
            </div>

            <div className={styles.card}>
              <div className={styles.cardIcon}>🖥️</div>
              <h3>Full Stack</h3>
              <p>
                End-to-end development from React and TypeScript frontends to JVM-based backends,
                databases, and cloud infrastructure. We own the entire delivery lifecycle.
              </p>
            </div>

            <div className={styles.card}>
              <div className={styles.cardIcon}>🤖</div>
              <h3>Agent Architectures</h3>
              <p>
                Building intelligent agent systems and AI-driven workflows that automate complex
                decision-making, orchestrate multi-step processes, and integrate seamlessly with
                existing platforms.
              </p>
            </div>

            <div className={styles.card}>
              <div className={styles.cardIcon}>🔒</div>
              <h3>Cybersecurity Systems</h3>
              <p>
                Developing security-first software including threat detection platforms, secure
                authentication systems, and compliance tooling that protect critical infrastructure.
              </p>
            </div>
          </div>
        </section>

        <section className={styles.cta}>
          <h2 className={styles.sectionTitle}>Work With Us</h2>
          <p>
            Whether you need a technology partner for a greenfield project, help modernizing a legacy
            system, or deep expertise on a specific initiative, we'd love to hear from you.
          </p>
          <Link to="/get-in-touch" className={styles.ctaButton}>
            Get in Touch
          </Link>
        </section>
      </div>
    </div>
  );
}
